import { type FunctionComponent } from 'react';
import { ACCOUNT_PROJECTS_LINK } from '../../../constants/links';
import { SHOWROOM_PREPARE_TODAY_WITH_PROJECTS_PHOTO_PUBLIC_ID } from '../../../constants/showroom';
import { LinkButton } from '../../buttons/link-button/link-button.component';
import { StyledLink } from '../../common-components/link/styled-link.component';
import { CloudinaryImage } from '../../images/cloudinary-image/cloudinary-image.component';

export const PrepareTodayWithProjects: FunctionComponent = () => {
	return (
		<section
			className="relative flex flex-column flex-row-ns br2 items-center bg-theme-primary-lighter"
			data-testid="prepare-today-with-projects">
			<PrepareTodayWithProjectsPhotoMobile />
			<PrepareTodayWithProjectsPhotoDesktop />
			<div className="w-80-ns w-50-m w-90 mh5">
				<h2 className="f3 f2-ns lh-title font-medium font-medium theme-primary mb1 mt3">Prepare Today with Projects</h2>
				<div className="f6 f5-ns lh-copy theme-gray-dark mb3">
					Tip: Use our <StyledLink url={ACCOUNT_PROJECTS_LINK}>Project Tool</StyledLink> to save your favorite products and
					organize them by project or room. You can easily share your selections with a Ferguson Home consultant for additional
					support.
				</div>
				<div className="mb4">
					<LinkButton buttonStyle="SECONDARY" url={ACCOUNT_PROJECTS_LINK}>
						Start A Project
					</LinkButton>
				</div>
			</div>
		</section>
	);
};

// TODO: EFDC-22045 end of epic code cleanup. See if we can reduce this to one image.
const PrepareTodayWithProjectsPhotoDesktop: FunctionComponent = () => (
	<>
		<div className="dn db-ns" style={{ width: '290px', height: '180px' }} />
		<div className="dn db-ns absolute left-0 top--2 ph4">
			<CloudinaryImage
				publicID={SHOWROOM_PREPARE_TODAY_WITH_PROJECTS_PHOTO_PUBLIC_ID}
				options={{ width: 242, height: 204, format: 'png' }}
				description="Project tool"
			/>
		</div>
	</>
);

const PrepareTodayWithProjectsPhotoMobile: FunctionComponent = () => (
	<>
		<div className="db dn-ns absolute top--2">
			<div className="flex items-center">
				<CloudinaryImage
					publicID={SHOWROOM_PREPARE_TODAY_WITH_PROJECTS_PHOTO_PUBLIC_ID}
					options={{ width: 170, height: 140, format: 'png' }}
					description="Project tool"
				/>
			</div>
		</div>
		<div className="db dn-ns" style={{ height: '100px' }} />
	</>
);
